<template>
  <div class="board-box" v-loading="loading">
    <!-- <select-range @range-change="rangeChange" /> -->
    <div :id="chartId" class="chart1" />
  </div>
</template>

<script>
import common from './mixins/common'

/**
 * 柱形图
 */
export default {
  mixins: [common],
  name: 'ChartBar5',
  props: {
    /**
     * 放置源头
     * - zjServiceType 总监-服务请求单 某个工程类型
     * - zjUnusual 总监-服务请求单 异常
     */
    source: {
      type: String,
      default: 'zjServiceType'
    },
    requestType: { type: String, default: '' }
  },
  data() {
    return {
      chartData: {},

      barConfig: {
        type: 'bar',
        emphasis: {
          focus: 'series'
        },
        avoidLabelOverlap: true,
        // barMinWidth: '14',
        barMaxWidth: '14',
        barMinHeight: '10',
        label: {
          show: true,
          position: 'top',
          distance: '0',
          // align: '',
          // verticalAlign: 'middle',
          // rotate: '90',
          formatter: '{c}',
          fontSize: 12,
          rich: {
            name: {}
          }
        }
      }
    }
  },
  computed: {
    conf: function() {
      // timeField 需配合 SQL 处理是否为本周月年的字段
      // trPrefix: time range prefix isWeek 等参数的前缀
      var that = this;
      const Map = {
        zjServiceType: {
          fieldConf: { xField: 'MANAGER_NAME', timeField: 'YW_WORK_ORDER_CREATE_TIME', trPrefix: 'YW_WORK_' },
          triggerClick:(data)=> {
            var uniqueId = data.name.split(",")[0] + '全部工程服务请求单';
            let condition = {};
            condition['MANAGER_NAME:2']  = data.name.split(",")[0];
            condition['WORK_ORDER_TYPE:1']  = that.requestType;
            that.baseComponent.smartLoadComponent('serviceRequest', {title: uniqueId, source: 'viewBoard', condition: condition, requestUniqueId: uniqueId}, {uniqueName: 'todo-' + uniqueId})
          }
          // fieldConf: { mock: true, xField: 'brand', timeField: '' }
        },
        zjUnusual: {
          fieldConf: { xField: 'MANAGER_NAME', timeField: 'YW_SERVICE_ORDER_CREATE_TIME', trPrefix: 'YW_WORK_' },
           triggerClick:(data)=> {
            var uniqueId = data.name.split(",")[0] + '全部异常服务请求';
            let condition = {};
            condition['MANAGER_NAME:2'] = data.name.split(",")[0];
            that.baseComponent.smartLoadComponent('serviceRequest', {title: uniqueId, source: 'viewBoard', condition: condition, requestUniqueId: '异常服务请求'}, {uniqueName: 'todo-' + uniqueId})
          }
          // fieldConf: { mock: true, xField: 'brand' }
        }
      }

      return Map[this.source] || {}
    }
  },
  watch: {
    chartData: function() {
      this.updateChart()
    },
    requestType: {
      handler: function(val) {
        if (val && this.source === 'zjServiceType') {
          this.getData()
        }
      }
    }
  },
  mounted: function() {
    this.getData()
  },
  methods: {
    updateChart: function() {
      let chartData = this.chartData,
        conf = this.conf
      let options = {
        legend: {
          left: '120',
          top: '27',
          data: chartData.legend
        },
        series: chartData.series,
        xAxis: [
          {
            type: 'category',
            triggerEvent: conf.triggerLabel,
            boundaryGap: true,
            data: chartData.xAxis || [],
            axisPointer: { type: 'shadow' }
          }
        ],
        yAxis: [
          {
            type: 'value',
            scale: true,
            name: '（个）',
            boundaryGap: [0.2, 0.2],
            min: 0,
            minInterval: 1
          }
        ],
        dataZoom: {
          show: true,
          start: 0,
          end: (10 * 100) / chartData.xAxis.length,
          height: 15
        },
        grid: { right: 30, left: 80 },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            snap: true,
            label: {
              backgroundColor: '#283b56'
            }
          }
        },
        toolbox: {
          show: false,
          feature: {
            dataView: { readOnly: false },
            restore: {},
            saveAsImage: {}
          }
        }
      }

      this.chartIns && this.chartIns.setOption(options)
    },

    /**
     * 处理数据
     * @param {[]} list
     */
    processList: function(list) {
      let { xField, trPrefix } = this.conf.fieldConf

      let series = [],
        xAxis = [],
        legend = [],
        total = 0

      let multiColMap = [
          { field: '本周', color: '#5BBAF9' },
          { field: '本月', color: '#5B8FF9' },
          { field: '本年', color: '#51C495' }
        ],
        categoryMap = {}

      list.map(v => {
        let curX = v[xField]
        /** 本周、本年、本月 */
        // let m = ''

        /** 某个 legend */
        // if (!multiColMap[m]) multiColMap[m] = true

        if (!categoryMap[curX]) categoryMap[curX] = { 本年: [], 本月: [], 本周: [] }
        // if (!categoryMap[curX][m]) categoryMap[curX][m] = []

        if (v[`${trPrefix}ISYEAR`]) categoryMap[curX]['本年'].push(v)
        if (v[`${trPrefix}ISMONTH`]) categoryMap[curX]['本月'].push(v)
        if (v[`${trPrefix}ISWEEK`]) categoryMap[curX]['本周'].push(v)
      })
      legend = multiColMap.map(m => m.field)

      xAxis = Object.keys(categoryMap)
      series = multiColMap.map(l => {
        let m = l.field

        let list = xAxis.map(curX => {
          let n = (categoryMap[curX][m] || []).reduce((total, cur) => (total += 1), 0)

          total += n
          return {
            name: [curX, m].join(','),
            value: n
          }
        })

        return {
          ...this.barConfig,
          name: m,
          itemStyle: { color: l.color },
          data: list
        }
      })

      this.chartData = { legend, xAxis, series, total }
    },
    getData() {
      let condition = this.condition,
        requestType = this.requestType,
        /** @type {import('../index.vue').IRoleId} */
        roleId = this.roleId,
        { mock, timeField } = this.conf.fieldConf,
        source = this.source

      this.loading = true
      let requestFn = ''
      if (source === 'zjServiceType') {
        condition[`${timeField}:2`] = new Date().getFullYear() + '%'
        condition['WORK_ORDER_TYPE:0'] = requestType
        requestType &&
          (requestFn = this.api.queryList(
            'YW_WORK_ORDER_DETAIL_V1',
            { p2: condition, p9: '' },
            `${roleId}_chartBar5_zjServiceType`
          ))
      } else if (source === 'zjUnusual') {
        condition[`${timeField}:2`] = new Date().getFullYear() + '%'
        requestFn = this.api.queryList(
          'YW_SERVICE_ORDER_YICHANG_V1',
          { p2: condition, p9: '' },
          `${roleId}_chartBar5_zjUnusual`
        )
      }
      requestFn &&
        requestFn.then(
          res => {
            this.loading = false
            let resData = (this.sourceList = res.result)

            // TODO: 模拟数据
            if (mock) {
              resData = this.genTableData(10)
            }

            this.processList(resData)
          },
          err => {
            this.loading = false
          }
        )
    }
  }
}
</script>

<style lang="postcss"></style>



// WEBPACK FOOTER //
// src/components/viewBoard/components/ChartBar5.vue